import { ContentTypes } from "#/_packages/umbrella/integrations/umbraco/utils/content-types.ts";
import type {
	DocTypeRendererMapping,
	DocTypeRendererProps,
} from "#/_packages/umbrella/integrations/umbraco/utils/renderer-mappings.tsx";
import { Search } from "#/app/components/search";

const gsaContentTypes = [ContentTypes.SearchPage];

function GsaContentTypeRenderer({
	content,
	breadcrumbs,
}: DocTypeRendererProps) {
	switch (content.contentType) {
		case ContentTypes.SearchPage:
			return <Search content={content} breadcrumbs={breadcrumbs} />;
	}
}

export const gsaContentTypeRenderers: DocTypeRendererMapping =
	Object.fromEntries(
		gsaContentTypes.map((contentType) => [contentType, GsaContentTypeRenderer]),
	);
